import { InfoEmployeds } from 'components/InfoEmployeds';
import styles from './PerformersItem.module.scss';
import { getFormatPhone } from 'utils/getFotmatPhone';
import { ItemsPerformersType } from 'redux/Api/performersWorkSupport/type';

interface PropsType {
  employed: ItemsPerformersType;
}

type StatusText = string;
type StatusColor = string;
type StatusItem = [StatusText, StatusColor];

export const PerformersItem = ({ employed }: PropsType) => {
  const textStatus: Record<string, StatusItem> = {
    '-1': ['Анкета исполнителя отклонена. Не получает заказы в приложении', '#E10D0D'],
    '0': [
      'Исполнитель не отправил документы на проверку. Не получает заказы в приложении',
      'rgb(113, 134, 157)',
    ],
    '1': ['Документы проверены', '#28A879'],
    '2': ['Исполнитель отправил документы, но они еще не проверены', '#FFD500'],
  };

  const statusInfo = textStatus[employed.verified?.toString()] ?? [
    'Неизвестный статус',
    '#000000',
  ];
  return (
    <div className={styles.root}>
      <div style={{ padding: '0 16px' }}>
        <InfoEmployeds
          avatar=''
          status={0}
          id={employed.id}
          name={employed?.fioI || 'Исполнитель'}
          surname={employed?.fioF || 'Неизвестный'}
          patronymic={employed?.fioO || ''}
        />
      </div>
      <p>{getFormatPhone(employed.phone) || ''}</p>
      <div className={styles.blockCircle}>
        <div className={styles.circle} style={{ background: statusInfo[1] }} />
        <p>{statusInfo[0]}</p>
      </div>
    </div>
  );
};
